
// package imports
import { Button, Container } from "react-bootstrap"
import { observer } from "mobx-react"
import moment from "moment"
import { toJS } from "mobx"

// project imports
import QmsStorageKeys from "constants/QmsStorageKeys"
import GapCampaignPageStore from "./gap-campaign-store"
import isObjectEmpty from "utils/isObjectEmpty";
import StorageKeys from "constants/StorageKeys"

import "./gap-campaign.css"
import QmsSolutionStatus from "constants/QmsSolutionStatus"
import PaginationComponent from "components/ui/pagination"
import fetchNavigationScreen from "utils/fetchNavigationScreen"
import QmsDropdown from "components/ui/qms-dropdown/QmsDropdown"
import { CustomCheckbox } from "components"
import SearchbarWithType from "components/ui/search-bar-with-type/SearchbarWithType"
import React, { useState, useEffect } from "react"
import CheckboxShareModal from "components/ui/checkobox-share-modal/CheckboxShareModal"
import ProductPackageIdForQms from "constants/ProductPackageIdForQms"
import MultiSelectWithSearchBox from "components/ui/multi-select-data-with-search-box/MultiSelectWithSearchBox"
import PasaLifeAssuredDetailsCard from "../components/pasa-life-assured-details-card/PasaLifeAssuredDetailsCard"
import BonusLifeAssuredDetailsCard from "../components/bonus-life-assured-details-card/BonusLifeAssuredDetailsCard"
import pasadummData from "../components/pasa-campaign/dummyPasaData"
import GapLifeAssuredDetailsCard from "../components/gap-life-assured-details-card/GapLifeAssuredDetailsCard"

const GapCampaign = observer((props) => {

    const [page, setPage] = useState(1);
    const [search, setSearch] = useState(null);
    const [regionalHeads, setRegionalHeads] = useState({ id: null, value: null });
    const [ch, setCh] = useState({ id: null, value: null });
    const [branchHeads, setBranchHeads] = useState({ id: null, value: null });
    const [dm, setDm] = useState({ id: null, value: null });
    const [pfa, setPfa] = useState({ id: null, value: null });
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [agentdata, setAgentdata] = useState(null);
    const [summeryData, setSummeryData] = useState(null);
    const [showpfa, setShowpfa] = useState(false);
    const [selectedType, setSelectedType] = useState('');
    const [selectedTypeValue, setSelectedTypeValue] = useState('');
    const [solutionCoverage, setSolutionCoverage] = useState([]);
    const [products, setProducts] = useState([]);
    const [viewFilter, setViewFilter] = useState(false);
    const [settitleQuote, setSettitleQuote] = useState("Show PFAs Quote");
    const [titleQuoteDisabled, setTitleQuoteDisabled] = useState(false);


    useEffect(() => {
        const fetchData = async () => {
            let agent_id;
            let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
            let agentsData = [];
            let channelName = ['OA', "CBM", 'DIS', 'IM'];

            const urlParams = new URLSearchParams(location.search);
            agent_id = sessionStorage.getItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE);
            if (!agent_id) {
                agent_id = localStorage.getItem(QmsStorageKeys.AGENT_ID);
            }

            await GapCampaignPageStore.savePragatiInBoundData(agent_id, page, search);

            let designation_Code = localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE);
            let origanal_designation_code = localStorage.getItem(QmsStorageKeys.ORIGANAL_DESIGNATION_CODE);
            let agent_name = localStorage.getItem(QmsStorageKeys.AGENT_NAME);
            let agent_code = localStorage.getItem(QmsStorageKeys.AGENT_CODE);

            if (channelName.includes(channel_code)) {
                channel_code === "DIS" ? setSettitleQuote("Show RMs Quote") : setSettitleQuote("Show PFAs Quote");

                agentsData = await GapCampaignPageStore.fetchAgentHeirarchy(designation_Code, agent_code, channel_code, origanal_designation_code);

                let current_date = new Date().toISOString().split('T')[0];
                const currentDate = moment();
                currentDate.date(1);
                const formattedDate = currentDate.format('YYYY-MM-DD');

                setStartDate(formattedDate);
                setEndDate(current_date);

                if (designation_Code.includes('RH')) {
                    setRegionalHeads({ id: agent_code, value: agent_name });
                    let response = await GapCampaignPageStore.fetchJourneySummary(agentsData[0].value, agentsData[1].value, agentsData[2].value, agentsData[3].value, agentsData[4].value, agent_code, "All", "All", "All", "All", channel_code)
                    setSummeryData(response.data);
                    setShowpfa(true);
                    setCh({ id: "All", value: "All" });
                    setBranchHeads({ id: "All", value: "All" });
                    setDm({ id: "All", value: "All" });
                    setPfa({ id: "All", value: "All" });

                    await GapCampaignPageStore.fetchPasaListData(
                        agentsData[3].value, agentsData[4].value, "All", "All", true,
                        agent_code, page, selectedType, selectedTypeValue, products, channel_code
                    );

                } else if (designation_Code.includes('CH')) {
                    setCh({ id: agent_code, value: agent_name });

                    let response = await GapCampaignPageStore.fetchJourneySummary(
                        agentsData[0].value, agentsData[1].value, agentsData[2].value, agentsData[3].value, agentsData[4].value,
                        null, agent_code, "All", "All", "All", channel_code
                    );

                    setSummeryData(response.data);
                    setShowpfa(true);
                    setBranchHeads({ id: "All", value: "All" });
                    setDm({ id: "All", value: "All" });
                    setPfa({ id: "All", value: "All" });

                    await GapCampaignPageStore.fetchPasaListData(
                        agentsData[3].value, agentsData[4].value, "All", "All", true,
                        agent_code, page, selectedType, selectedTypeValue, products, channel_code
                    );

                } else if (designation_Code.includes('BH') || designation_Code.includes('TM')) {
                    setBranchHeads({ id: agent_code, value: agent_name });

                    let response = await GapCampaignPageStore.fetchJourneySummary(
                        agentsData[0].value, agentsData[1].value, agentsData[2].value, agentsData[3].value, agentsData[4].value,
                        null, null, agent_code, "All", "All", channel_code
                    );

                    setSummeryData(response.data);
                    setShowpfa(true);
                    setDm({ id: "All", value: "All" });
                    setPfa({ id: "All", value: "All" });

                    await GapCampaignPageStore.fetchPasaListData(
                        agentsData[3].value, agentsData[4].value, "All", "All", true,
                        agent_code, page, selectedType, selectedTypeValue, products, channel_code
                    );

                } else if (designation_Code.includes('DM') || designation_Code.includes('BM')) {
                    setDm({ id: agent_code, value: agent_name });

                    let response = await GapCampaignPageStore.fetchJourneySummary(
                        agentsData[0].value, agentsData[1].value, agentsData[2].value, agentsData[3].value, agentsData[4].value,
                        null, null, null, agent_code, "All", channel_code
                    );

                    setSummeryData(response.data);
                    setShowpfa(true);
                    setPfa({ id: "All", value: "All" });

                    await GapCampaignPageStore.fetchPasaListData(
                        agentsData[3].value, agentsData[4].value, agent_code, "All", true,
                        agent_code, page, selectedType, selectedTypeValue, products, channel_code
                    );

                } else if (designation_Code.includes('PFA') || designation_Code.includes('RM')) {
                    setPfa({ id: agent_code, value: agent_name });

                    let response = await GapCampaignPageStore.fetchJourneySummary(
                        agentsData[0].value, agentsData[1].value, agentsData[2].value, agentsData[3].value, agentsData[4].value,
                        null, null, null, null, agent_code, channel_code
                    );

                    setSummeryData(response.data);
                    setShowpfa(true);
                    setTitleQuoteDisabled(true);

                    await GapCampaignPageStore.fetchPasaListData(
                        agentsData[3].value, agentsData[4].value, null, agent_code, true,
                        agent_code, page, selectedType, selectedTypeValue, products, channel_code
                    );

                }

                setAgentdata(agentsData);
            }

            fetchNavigationScreen();
        };

        fetchData();
    }, []);

    const showSingleCard = (proposerList) => {
        if (proposerList) {
            return proposerList.some((item) => item.solution_list[0].solution_status_id !== QmsSolutionStatus.ANALYSIS_IN_PROGRESS);
        } else {
            return false;
        }
    };

    const onPageChange = async (pageNumber) => {
        let data = agentdata;
        let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
        let channelName = ['OA', 'CBM', 'DIS', 'IM'];
        let designation_Code = localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE);

        if (page !== pageNumber) {
            setPage(pageNumber);
            let agent_code = localStorage.getItem(QmsStorageKeys.AGENT_CODE);

            if (channelName.includes(channel_code)) {
                let dmID = dm.id;
                let pfaID = pfa.id;

                await GapCampaignPageStore.fetchPasaListData(
                    data[3].value, data[4].value, dmID, pfaID, true,
                    agent_code, pageNumber, selectedType, selectedTypeValue, products, channel_code
                );
            } else {
                const urlParams = new URLSearchParams(location.search);
                let agent_id = sessionStorage.getItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE);

                if (!agent_id) {
                    agent_id = localStorage.getItem(QmsStorageKeys.AGENT_ID);
                }

                await GapCampaignPageStore.fetchQmsListData(agent_id, pageNumber, search, agent_code);
            }
        }
    };

    const ondatachanges = (data, name, id) => {
        let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];

        if (name === "Region Heads") {
            setRegionalHeads({ id: id, value: data });
        } else if (name === "CH") {
            setCh({ id: id, value: data });

            let role = channel_code === "IM" ? "tm" : "bh";
            let newagentData = GapCampaignPageStore.updateAgentHeirarchy(data, agentdata, role);

            setAgentdata(newagentData);
            setBranchHeads({ id: "All", value: "All" });

        } else if (name === "Branch Heads" || name === "TM") {
            setBranchHeads({ id: id, value: data });

            let role = GapCampaignPageStore.setRole(name, channel_code);
            let newagentData = GapCampaignPageStore.updateAgentHeirarchy(data, agentdata, role);

            setAgentdata(newagentData);
            setDm({ id: "All", value: "All" });

        } else if (name === "DM" || name === "BM") {
            setDm({ id: id, value: data });

            let role = GapCampaignPageStore.setRole(name, channel_code);
            let newagentData = GapCampaignPageStore.updateAgentHeirarchy(data, agentdata, role);

            setAgentdata(newagentData);
            setPfa({ id: "All", value: "All" });

        } else if (name === "PFA" || name === "RM") {
            setPfa({ id: id, value: data });

        } else if (name === "solution coverage") {
            setSolutionCoverage(data);

        } else if (name === "product") {
            setProducts(data);
        }
    };

    const onSelectedTypeChange = (type, value) => {
        setSelectedType(type);
        setSelectedTypeValue(value);
    };

    const handleSearchData = (data) => {
        if (data !== '') {
            setSearch(data);
            setPage(1);
        } else {
            setSearch(null);
        }
    };

    const filterData = async () => {
        let data = agentdata;
        let agent_code = localStorage.getItem(QmsStorageKeys.AGENT_CODE);
        let designation_Code = localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE);
        let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];

        let rhID = regionalHeads.id;
        let bhID = branchHeads.id;
        let dmID = dm.id;
        let pfaID = pfa.id;
        let chID = ch.id;

        let showPfa = titleQuoteDisabled ? true : showpfa;

        // let solution = solutionCoverage.includes("All") ? ["All"] : solutionCoverage;

        let response = await GapCampaignPageStore.fetchJourneySummary(
            data[0].value, data[1].value, data[2].value, data[3].value, data[4].value,
            rhID, chID, bhID, dmID, pfaID, channel_code
        );

        setSummeryData(response.data);

        await GapCampaignPageStore.fetchPasaListData(
            data[3].value, data[4].value, dmID, pfaID, showPfa,
            agent_code, page, selectedType, selectedTypeValue, products, channel_code
        );
    };

    const showQmsList = async (showPFA) => {
        let data = agentdata;
        let agent_code = localStorage.getItem(QmsStorageKeys.AGENT_CODE);
        let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
        let dmID = dm.id;
        let pfaID = pfa.id;

        await GapCampaignPageStore.fetchPasaListData(
            data[3].value, data[4].value, dmID, pfaID, showPFA,
            agent_code, page, selectedType, selectedTypeValue, products, channel_code
        );
    };

    const shareDocumentList = async (data) => {

        const saveDocumentData = await GapCampaignPageStore.processDocumnetList(data)

        if (saveDocumentData.status === "success") {
            GapCampaignPageStore.setshowDocumentList(false)
            let quotationStatusFormObj = document.getElementById(`pragati-out-oubound-form-post-call-uniqueId-${GapCampaignPageStore.productCardUniqueId}`);
            console.log("quotationStatusFormObj formObj :: ", quotationStatusFormObj);
            quotationStatusFormObj.submit();

            // let quotationStatusFormObj = document.getElementById(`quotation-status-form-post-call-uniqueId-${GapCampaignPageStore.productCardUniqueId}`);
            // console.log("quotationStatusFormObj formObj :: ", quotationStatusFormObj);
            // quotationStatusFormObj.submit();
        }

    }

    let summaryData = summeryData;
    let channelName = ['OA', 'CBM', 'DIS', 'IM'];
    let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
    let pasaData = toJS(GapCampaignPageStore.pasaListData)
    // let pasaData = pasadummData
    console.log("pasaData ", pasaData)
    return (
        <>
            {
                (!isObjectEmpty(pasaData) || channelName.includes(channel_code)) ? (
                    <Container className="qms-dashboard-page mt-5 mt-md-3">
                        <div className="row">
                            <div className="col-4 col-lg-6">
                                <Button className="w-100 mt-2 font-size-14 view-filter" onClick={() => setViewFilter(!viewFilter)}>{viewFilter ? "Hide Filters" : "View Filters"}</Button>
                            </div>
                            <div className="col-8 col-lg-6">
                                <SearchbarWithType
                                    onSelectedTypeChange={onSelectedTypeChange}
                                    searchButtonClick={showQmsList}

                                />
                            </div>
                        </div>

                        {viewFilter && (
                            <div className="mb-3">
                                <div className="row">
                                    {agentdata &&
                                        <>
                                            {agentdata.map((item, index) => (
                                                <div className="col-3-5" key={index}>
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <p className='font-size-14 mb-2 agent-name'>{GapCampaignPageStore.agentName(item.key)}</p>
                                                    </div>
                                                    <QmsDropdown
                                                        title={GapCampaignPageStore.agentName(item.key)}
                                                        item={item.value}
                                                        menuItemStyle='d-flex justify-content-between align-items-center'
                                                        dropdownStyle='font-size-14'
                                                        datachnages={ondatachanges}
                                                        RHs={regionalHeads.value}
                                                        BHs={branchHeads.value}
                                                        DMs={dm.value}
                                                        PFAs={pfa.value}
                                                        CHs={ch.value}
                                                    />
                                                </div>
                                            ))}

                                            <div className="col-3-5 ">
                                                <div className='d-flex justify-content-between align-items-center mt-2 mt-lg-0 '>
                                                    <p className='font-size-14 mb-2 agent-name'>Product</p>
                                                </div>
                                                <MultiSelectWithSearchBox
                                                    productsList={ProductPackageIdForQms.value}
                                                    datachnages={ondatachanges}
                                                />
                                            </div>
                                        </>
                                    }

                                </div>
                                <div className="d-flex justify-content-end">
                                    <div className="pasa-filter-button my-2">
                                        <Button className="drp-applyBtn-Style rounded-pill font-size-16 w-100" onClick={filterData} >Filter</Button>
                                    </div>
                                </div>
                            </div>

                        )}

                        <div className="row">
                            <div className="col-lg-10 mb-3">
                                {summaryData && (
                                    <div>
                                        <table className="pasa-summary-table">
                                            <thead>
                                                <tr>
                                                    {/* <th>Role</th> */}
                                                    <th>Particulars</th>
                                                    <th>Total Opportunity Gap</th>
                                                    <th>Reconnected Leads</th>
                                                    <th>Converted</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="pasa-tr">
                                                    <td>Count of Leads</td>
                                                    <td>{summaryData?.number_of_leads}</td>
                                                    <td>{summaryData?.number_of_quotes_shared}</td>
                                                    <td>{summaryData?.number_of_logins}</td>
                                                </tr>
                                                <tr className="pasa-tr">
                                                    <td>Value of Leads (APE)</td>
                                                    <td>{summaryData?.number_of_leads_ape}</td>
                                                    <td>{summaryData?.number_of_quotes_shared_ape}</td>
                                                    <td>{summaryData?.number_of_logins_ape}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                            <div className="col-lg-2 mt-2">
                                {summaryData && (
                                    <div className="d-flex justify-content-end mt-lg-4">
                                        <CustomCheckbox
                                            shape="rounded"
                                            title={settitleQuote}
                                            titleStyle='font-weight-medium font-size-14 pl-2 text-primary'
                                            isChecked={showpfa}
                                            onChange={(value) => {
                                                setShowpfa(value);
                                                showQmsList(!showpfa);
                                            }}
                                            disabled={titleQuoteDisabled}
                                            mark="checkmark"
                                        />
                                    </div>
                                )}
                            </div>

                        </div>

                        <p className=" border text-justify rounded p-2 text">The benefits provided includes guaranteed and non-guaranteed benefits. The non-guaranteed benefits are arrived at 8% rate of return p.a. This is an assumed rate of return and is not guaranteed. Kindly refer the Benefit Illustration of the respective product to understand the benefits available under the policy at an assumed rate of 4% & 8% p.a</p>
                        {!isObjectEmpty(pasaData) &&
                            <GapLifeAssuredDetailsCard
                                LADetails={pasaData}
                            />

                        }

                        {
                            (!isObjectEmpty(pasaData) && search === null && pasaData.number_of_pages !== 1) && <PaginationComponent
                                onChangePage={onPageChange}
                                // totalItemCount={100}
                                selectedPage={page}
                                totalPageCount={pasaData?.number_of_pages}
                            />
                        }
                    </Container>
                )
                    :
                    <div></div>
            }

            {GapCampaignPageStore.showDocumentList &&
                <CheckboxShareModal
                    show={GapCampaignPageStore.showDocumentList}
                    yesShowCheckboxShareModal={shareDocumentList}
                    noShowCheckboxShareModal={() => { GapCampaignPageStore.setshowDocumentList(false) }}
                // proceedSoluctionToQmsScreen={this.proceedSoluctionToQmsScreen}
                />
            }
        </>
    )
})
export default GapCampaign;